import {
  CREATE_BRAND,
  CREATE_BRAND_ERROR,
  CREATE_BRAND_SUCCESS,
  GET_BRAND,
  GET_BRAND_DATA_NEW,
  GET_BRAND_DATA_NEW_ERROR,
  GET_BRAND_DATA_NEW_SUCCESS,
  GET_BRAND_ERROR,
  GET_BRAND_SUCCESS,
  UPDATE_BRAND,
  UPDATE_BRAND_ERROR,
  UPDATE_BRAND_SUCCESS,
} from "../actions/brandAction"

const initialState = {
  brandData: [],
  brands: [],
  data: {},
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
  updating: false,
  updated: false,
  error: null,
}

export default function brandReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BRAND:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      }

    case GET_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        brandData: action.payload.success,
      }

    case GET_BRAND_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        brandData: [],
      }

    case CREATE_BRAND:
      return {
        ...state,
        saving: true,
        saved: false,
        error: null,
      }

    case CREATE_BRAND_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
        data: action.payload.success,
      }

    case CREATE_BRAND_ERROR:
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload.error,
        data: {},
      }

    case UPDATE_BRAND:
      return {
        ...state,
        updating: true,
        updated: false,
        error: null,
      }

    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        updating: false,
        updated: true,
        data: action.payload.success,
      }

    case UPDATE_BRAND_ERROR:
      return {
        ...state,
        updating: false,
        updated: false,
        error: action.payload.error,
        data: {},
      }

    case GET_BRAND_DATA_NEW:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      }

    case GET_BRAND_DATA_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        brands: action.payload.success,
      }

    case GET_BRAND_DATA_NEW_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        brands: [],
      }

    default:
      return state
  }
}
